import * as _ from 'lodash';

// get actual required value for conditional field
// conditionals - scorecardSegment.conditionals for field
export const getFieldRequiredValue = (conditionals, formGroupControls): boolean => {
  let required = false;

  _.forEach(conditionals.is_required_when, rule => {
    if (!rule || !rule.fieldMap) {
      return;
    }

    const groupControl = formGroupControls[rule.fieldMap];
    if (!groupControl) {
      required = true;
    }

    const requiredByCondition = (rule.value ? (groupControl.value === rule.value) :
      !!(groupControl.value && groupControl.value.length));
    required = required || requiredByCondition;
  });
  
  return required;
};
